export default "__VITE_ASSET__COyBJ18n__"